import React from 'react'
import { connect } from 'react-redux'
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl,
  FormControlLabel, FormGroup, FormLabel, Switch, TextField
} from '@mui/material'
import pick from 'lodash.pick'
import merge from 'lodash.merge'
import { formUpdate } from '../lib/form'
import { rxEnterRoom } from '../lib/rx_subject'
import { initUser } from '../lib/user'
import { saveSetting } from '../redux/actions/setting'
import ColorSelector from '../components/ColorSelector'

const EnterRoom = ({ submit, setting, saveSetting }) => {
  const [open, setOpen] = React.useState(false)
  const [room, setRoom] = React.useState(null)
  const [first, setFirst] = React.useState(false)
  const [form, setForm] = React.useState({
    ...pick(initUser, ['name', 'chatAnswer', 'color']),
    title: '',
    password: '',
    observer: false
  })

  React.useEffect(() => {
    const subscription = rxEnterRoom.subscribe(room => {
      setRoom(room)
      setFirst(room.numUsers === 0)
      setOpen(true)
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [])

  React.useEffect(() => {
    setForm(form => merge({}, form, setting.user))
  }, [setting.user])

  const onEnter = () => {
    setForm(form => merge({}, form, {
      ...setting.user,
      title: !first && room.title === '' ? `(Room${room.no})` : room.title,
      password: !first && !room.hasPassword ? '(不要)' : '',
      observer: false
    }))
  }

  const change = formUpdate(setForm)

  const onSubmit = evt => {
    evt.preventDefault()
    saveSetting({ user: pick(form, ['name', 'chatAnswer', 'color']) })

    const tag = first ? { title: form.title, password: form.password } : { password: form.password }
    submit({
      ...pick(form, ['name', 'observer', 'chatAnswer', 'color']),
      roomNo: room.no,
      first,
      tag
    })

    close()
  }

  const close = () => {
    setOpen(false)
  }

  return (
    <Dialog className="enter-room-dialog" open={open}
            TransitionProps={{ onEnter }}
            aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">入室</DialogTitle>
      <DialogContent className="enter-room">
        <form id="enter-room-form" onSubmit={onSubmit}>
          <FormGroup className="form-group group-title">
            <FormControl>
              <TextField variant="standard" label="ハンドル"
                         className="name"
                         inputProps={{ required: true, maxLength: 9 }}
                         value={form.name} onChange={change.value('name')} />
            </FormControl>
          </FormGroup>
          <FormGroup className="form-group" sx={{ mt: '5px' }}>
            <FormControl>
              <TextField variant="standard" label="部屋名"
                         className="title"
                         inputProps={{ readOnly: !first, maxLength: 20 }}
                         value={form.title} onChange={change.value('title')} />
            </FormControl>
          </FormGroup>
          <FormGroup className="form-group" sx={{ mt: '5px' }}>
            <FormControl>
              <TextField variant="standard" label="合言葉"
                         className="password" autoComplete="off"
                         disabled={!first && room && !room.hasPassword}
                         inputProps={{ maxLength: 20 }}
                         value={form.password} onChange={change.value('password')} />
            </FormControl>
          </FormGroup>
          <FormGroup className="form-group" sx={{ mt: '10px' }}>
            <FormControl>
              <FormControlLabel
                control={
                  <Switch color="primary" className="observer"
                          checked={form.observer} onChange={change.checked('observer')} />
                }
                label="観戦" disabled={first} />
            </FormControl>
          </FormGroup>
          <FormGroup className="form-group">
            <FormControl>
              <FormControlLabel
                control={
                  <Switch color="primary" className="chat-answer"
                          checked={form.chatAnswer} onChange={change.checked('chatAnswer')} />
                }
                label="チャット解答マーク" />
            </FormControl>
          </FormGroup>
          <FormGroup className="form-group" sx={{ mt: '10px' }}>
            <FormControl className="border-color">
              <FormLabel>枠の色</FormLabel>
              <ColorSelector value={form.color} onChange={change.direct('color')} />
            </FormControl>
          </FormGroup>
        </form>
      </DialogContent>
      <DialogActions>
        <Button type="submit" form="enter-room-form"
                className="submit" color="primary">
          入室
        </Button>
        <Button className="close" color="secondary" onClick={close}>
          キャンセル
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default connect(
  state => ({
    setting: state.setting
  }),
  dispatch => ({
    saveSetting: setting => dispatch(saveSetting(setting))
  })
)(EnterRoom)
